import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Star } from 'lucide-react';
import { reviewsAPI } from '../services/api';
import { useT } from '../services/i18n';

let cache;

/** Site-wide floating « ★ sur Google » pill (bottom-left), fed by the Google Business cache; hidden in admin or without data. */
const GoogleRatingBadge = () => {
  const { t } = useT();
  const { pathname } = useLocation();
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache !== undefined) return;
    reviewsAPI.googleBusiness().then((d) => { cache = d || null; setData(cache); }).catch(() => { cache = null; setData(null); });
  }, []);
  if (!data || data.rating == null || pathname.startsWith('/admin')) return null;
  return (
    <a href={data.url || '#'} target="_blank" rel="noopener noreferrer" data-testid="google-rating-badge" aria-label={t('home.google.title')}
      className="fixed bottom-4 left-4 z-40 inline-flex items-center gap-2 rounded-full bg-white/95 backdrop-blur border border-gray-200 shadow-lg pl-2 pr-3 py-1.5 text-xs font-semibold text-gray-800 hover:shadow-xl hover:-translate-y-0.5 transition-[transform,box-shadow]">
      <svg viewBox="0 0 48 48" width="18" height="18" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z"/><path fill="#FBBC05" d="M10.5 28.7c-.5-1.5-.8-3-.8-4.7s.3-3.2.8-4.7l-7.9-6.1C.9 16.6 0 20.2 0 24s.9 7.4 2.6 10.8l7.9-6.1z"/><path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.5-5.8c-2.1 1.4-4.8 2.3-8.1 2.3-6.3 0-11.6-4.1-13.5-9.8l-7.9 6.1C6.5 42.6 14.6 48 24 48z"/></svg>
      <span data-testid="google-rating-badge-value">{Number(data.rating).toFixed(1)}</span>
      <Star size={13} className="fill-yellow-400 text-yellow-400 -ml-1" />
      <span className="font-normal text-gray-600">{t('home.google.badge', { n: data.count || 0, count: data.count || 0 })}</span>
    </a>
  );
};

export default GoogleRatingBadge;
